import { Card, CardContent, CardHeader, CardTitle } from '../Card';
import {
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableHead,
  TableRow,
} from '../Table';

export function AccountIssueRowSkeleton() {
  return (
    <TableRow>
      <TableCell className="font-medium">
        <div className="h-5 w-32 bg-gray-200 rounded-md animate-pulse"></div>
      </TableCell>
      <TableCell>
        <div className="h-5 w-36 bg-gray-200 rounded-md animate-pulse"></div>
      </TableCell>
      <TableCell>
        <div className="h-5 w-24 bg-gray-200 rounded-md animate-pulse"></div>
      </TableCell>
      <TableCell>
        <div className="h-5 w-36 bg-gray-200 rounded-md animate-pulse"></div>
      </TableCell>
      <TableCell>
        <div className="h-5 w-full bg-gray-200 rounded-md animate-pulse"></div>
      </TableCell>
      <TableCell>
        <div className="h-5 w-20 bg-gray-200 rounded-md animate-pulse"></div>
      </TableCell>
      <TableCell className="flex gap-2 items-center">
        <div className="h-5 w-5 rounded-full bg-gray-200 animate-pulse"></div>
        <div className="h-5 w-5 rounded-full bg-gray-200 animate-pulse"></div>
        <div className="h-5 w-5 rounded-full bg-gray-200 animate-pulse"></div>
      </TableCell>
    </TableRow>
  );
}

export function AccountIssueMobileItemSkeleton() {
  return (
    <div className="flex flex-col gap-2 rounded-lg border p-4 mb-3">
      <div className="flex items-center justify-between gap-3">
        <div className="w-6 h-6 bg-gray-200 rounded-md animate-pulse"></div>
        <div className="flex flex-1">
          <div className="flex flex-col gap-0.5">
            <div className="h-5 w-36 bg-gray-200 rounded-md animate-pulse mb-1"></div>
            <div className="h-4 w-24 bg-gray-200 rounded-md animate-pulse"></div>
          </div>
        </div>
        <div className="h-5 w-20 bg-gray-200 rounded-md animate-pulse"></div>
      </div>
      <div className="flex flex-col gap-3">
        <div className="flex justify-between gap-3">
          <div>
            <div className="h-4 w-20 bg-gray-200 rounded-md animate-pulse mb-1"></div>
            <div className="h-5 w-24 bg-gray-200 rounded-md animate-pulse"></div>
          </div>
          <div>
            <div className="h-4 w-20 bg-gray-200 rounded-md animate-pulse mb-1"></div>
            <div className="h-5 w-36 bg-gray-200 rounded-md animate-pulse"></div>
          </div>
        </div>
        <div>
          <div className="h-4 w-32 bg-gray-200 rounded-md animate-pulse mb-1"></div>
          <div className="h-5 w-full bg-gray-200 rounded-md animate-pulse"></div>
        </div>
      </div>
      <div className="flex gap-2 mt-1">
        <div className="h-8 w-16 bg-gray-200 rounded-md animate-pulse"></div>
        <div className="h-8 w-16 bg-gray-200 rounded-md animate-pulse"></div>
      </div>
    </div>
  );
}

const AccountIssuesSkeleton = () => {
  return (
    <Card className="flex-1">
      <CardHeader className="flex flex-col gap-4 md:py-5 md:px-6 md:items-center md:justify-between md:flex-row">
        <CardTitle className="text-base font-medium">
          <div className="h-6 w-48 bg-gray-200 rounded-md animate-pulse"></div>
        </CardTitle>
        <div className="flex flex-col gap-3 md:gap-4 md:flex-row">
          {/* Search Bar Skeleton */}
          <div className="relative">
            <div className="absolute left-3 h-full flex items-center justify-center">
            </div>
            <div className="w-full h-10 bg-gray-200 rounded-lg animate-pulse"></div>
          </div>
          
          {/* Filter Dropdowns Skeleton */}
          <div className="flex gap-2 justify-around">
            <div className="relative flex-1">
              <div className="w-full h-10 flex items-center justify-between px-3 border border-gray-200 rounded-lg">
                <div className="flex items-center gap-1">
                  <div className="h-5 w-28 bg-gray-200 rounded-md animate-pulse"></div>
                </div>
                <div className="h-4 w-4 bg-gray-200 rounded-md animate-pulse"></div>
              </div>
            </div>
            <div className="relative flex-1">
              <div className="w-full h-10 flex items-center justify-between px-3 border border-gray-200 rounded-lg">
                <div className="flex items-center gap-1">
                  <div className="h-5 w-24 bg-gray-200 rounded-md animate-pulse"></div>
                </div>
                <div className="h-4 w-4 bg-gray-200 rounded-md animate-pulse"></div>
              </div>
            </div>
          </div>
        </div>
      </CardHeader>
      <CardContent className="py-0 md:py-0 md:border-t border-t-gray-200">
        {/* Desktop Table Skeleton */}
        <Table className="hidden md:table">
          <TableHeader>
            <TableRow>
              <TableHead className="text-gray-400">
                <div className="h-5 w-16 bg-gray-200 rounded-md animate-pulse"></div>
              </TableHead>
              <TableHead className="text-gray-400">
                <div className="h-5 w-28 bg-gray-200 rounded-md animate-pulse"></div>
              </TableHead>
              <TableHead className="text-gray-400">
                <div className="h-5 w-24 bg-gray-200 rounded-md animate-pulse"></div>
              </TableHead>
              <TableHead className="text-gray-400">
                <div className="h-5 w-28 bg-gray-200 rounded-md animate-pulse"></div>
              </TableHead>
              <TableHead className="text-gray-400">
                <div className="h-5 w-36 bg-gray-200 rounded-md animate-pulse"></div>
              </TableHead>
              <TableHead className="text-gray-400">
                <div className="h-5 w-20 bg-gray-200 rounded-md animate-pulse"></div>
              </TableHead>
              <TableHead className="text-gray-400"></TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            <AccountIssueRowSkeleton />
            <AccountIssueRowSkeleton />
            <AccountIssueRowSkeleton />
            <AccountIssueRowSkeleton />
            <AccountIssueRowSkeleton />
          </TableBody>
        </Table>
        
        {/* Mobile View Skeleton */}
        <div className="md:hidden">
          <AccountIssueMobileItemSkeleton />
          <AccountIssueMobileItemSkeleton />
          <AccountIssueMobileItemSkeleton />
          <AccountIssueMobileItemSkeleton />
          <AccountIssueMobileItemSkeleton />
        </div>
      </CardContent>
    </Card>
  );
};

export default AccountIssuesSkeleton;